<!-- eslint-disable vue/multi-word-component-names -->
<!-- 忘记密码（独立页面）：邮箱 + 验证码 → 重设密码
     · 左侧沿用登录页的品牌区（与 Login.vue 的 .login_box1 保持同一套样式）
     · 右侧布局与 Login.vue 的 .login_box2 对齐：内容整体垂直居中、表单区 350px 宽、
       页脚居中在内容下方
     · 输入框与主按钮**不写死尺寸**，全部跟随 assets/theme 主题 ——
       实测登录页就是主题默认值（输入框 40px 高 / 4px 圆角 / 描边 #dcdfe6 /
       文字 #606266 / hover #c0c4cc / focus #ff4d90；按钮 40px 高 / 4px 圆角），
       两页共用同一套值，以后改主题会自动同步
     · 框间距 24px，与登录页 .input_one 的下边距一致
     后端接口：POST /api/sendResetCode、POST /api/resetPassword -->
<template>
  <div class="forget_box">
    <!-- 左：品牌区（与登录页一致，不要单独改这里） -->
    <div class="forget_box1">
      <p>AI云书签管理系统</p>
    </div>

    <!-- 右：表单区（布局与登录页 .login_box2 对齐） -->
    <div class="forget_box2">
      <div class="forget_panel">
        <h1 class="fp_title">忘记密码</h1>
        <p class="fp_sub">输入注册邮箱，我们会发送一封重置密码的邮件给你。</p>

        <el-form ref="resetForm" :model="resetForm" :rules="rules" class="fp_form">
          <el-form-item prop="email">
            <el-input
              v-model="resetForm.email"
              placeholder="请输入邮箱地址"
              @keyup.enter.native="sendCode"
            ></el-input>
          </el-form-item>

          <el-form-item prop="code" class="fp_item_code">
            <el-input
              v-model="resetForm.code"
              maxlength="6"
              placeholder="请输入邮箱验证码"
            >
              <template #suffix>
                <el-button
                  type="text"
                  class="fp_code_btn"
                  :disabled="isDisabled"
                  @click="sendCode"
                >{{ countdown > 0 ? `${countdown}s` : '获取验证码' }}</el-button>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model="resetForm.password"
              type="password"
              maxlength="15"
              placeholder="请输入新密码"
              @keyup.enter.native="submit"
            ></el-input>
          </el-form-item>
        </el-form>

        <el-button type="primary" class="fp_submit" :loading="submitting" @click="submit">
          确认
        </el-button>

        <div class="fp_back_row">
          <el-link type="primary" :underline="false" @click="$router.push('/login')">返回登录</el-link>
        </div>
      </div>

      <div class="fp_footer">
        <div class="fp_copyright">Copyright © {{ new Date().getFullYear() }} 站存存</div>
        <el-link
          class="fp_beian"
          href="https://beian.mps.gov.cn/#/query/webSearch?code=41140002000709"
          target="_blank"
        >豫公网安备41140002000709号</el-link>
        <el-link class="fp_beian" href="https://beian.miit.gov.cn" target="_blank">豫ICP备2025142573号</el-link>
      </div>
    </div>
  </div>
</template>

<script>
import { sendResetCodeAPI, resetPasswordAPI } from '@/api'

export default {
  name: 'ForgetPwd',
  data () {
    return {
      resetForm: {
        email: '',
        code: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '验证码为 6 位数字', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
        ]
      },
      countdown: 0, // 倒计时秒数（与注册页一致，180 秒）
      isDisabled: false, // 「获取验证码」禁用状态
      timer: null, // 倒计时定时器句柄
      submitting: false // 提交中
    }
  },
  created () {
    // 从登录页跳进来时带上邮箱，省得再输一遍
    const email = this.$route.query.email
    if (email) this.resetForm.email = String(email)
  },
  beforeDestroy () {
    // 组件销毁时清理倒计时定时器，避免内存泄漏
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    // 获取验证码：只校验邮箱格式，不触发整表校验（否则会被空验证码/空密码拦住）
    async sendCode () {
      const email = (this.resetForm.email || '').trim()
      if (!email) return this.$message.error('请填写邮箱地址')
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        return this.$message.error('请输入正确的邮箱地址')
      }

      try {
        const { data } = await sendResetCodeAPI(email)
        if (data.code === 0) {
          this.$message.success('验证码已发送（3 分钟内有效），请查收邮件')
          this.startCountdown()
        } else {
          this.$message.error(data.message || '发送验证码失败')
        }
      } catch (error) {
        // 后端以 HTTP 400/500 返回业务错误（如"该邮箱未注册"），提示语在 response.data.message
        const msg = error.response && error.response.data && error.response.data.message
        this.$message.error(msg || '网络异常，请稍后重试')
      }
    },

    startCountdown () {
      this.countdown = 180
      this.isDisabled = true
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.timer)
          this.timer = null
          this.isDisabled = false
        }
      }, 1000)
    },

    submit () {
      this.$refs.resetForm.validate(async (valid) => {
        if (!valid) return false

        this.submitting = true
        const email = this.resetForm.email.trim()

        try {
          const { data } = await resetPasswordAPI({
            email,
            code: this.resetForm.code,
            password: this.resetForm.password
          })

          if (data.code !== 0) {
            this.$message.error(data.message || '重置失败')
            this.submitting = false
            return
          }

          this.$message.success('密码已重置，请使用新密码登录')
          // 回登录页并带上邮箱，登录页会自动回填
          this.$router.push({ path: '/login', query: { email } })
        } catch (error) {
          const msg = error.response && error.response.data && error.response.data.message
          this.$message.error(msg || '重置失败，请稍后重试')
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
/* ── 左：与 Login.vue 的 .login_box1 完全一致 ── */
.forget_box {
  display: flex;
  height: 100vh;
}

.forget_box1 {
  width: 36%;
  background-color: #F2CED8;
  background-image: url("../assets/sign-in.jpeg");
  background-size: contain;
  background-repeat: no-repeat, repeat;
  background-position: 0% 100%;
}

.forget_box1 p {
  color: #fff9fa;
  font-size: 36px;
  padding-top: 80px;
  display: flex;
  justify-content: center;
}

/* ── 右：与 Login.vue 的 .login_box2 同一套布局（内容垂直居中、列内水平居中）── */
.forget_box2 {
  width: 64%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

/* 表单区 350px —— 与登录页 .haf 同宽 */
.forget_panel {
  width: 350px;
}

.fp_title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.4;
  color: #1d1d1f;
}

.fp_sub {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: #666666;
}

/* 表单：无 label，纯 placeholder 引导。
   输入框的尺寸 / 圆角 / 描边 / 字号 / 文字色 / hover / focus 全部交给主题，
   不在这里写死 —— 这样与登录页必然一致，改主题两页同步 */
.fp_form {
  margin-top: 24px;
}

/* 行距 24px，与登录页 .input_one 的下边距一致 */
.fp_form ::v-deep .el-form-item {
  margin-bottom: 24px;
}

/* 验证码框：给框内右侧的「获取验证码」留出位置 */
.fp_item_code ::v-deep .el-input__inner {
  padding-right: 118px;
}

/* 让后缀按钮在输入框内垂直居中（不依赖固定行高，换任何框高都对） */
.fp_item_code ::v-deep .el-input__suffix {
  right: 15px;
  display: flex;
  align-items: center;
  line-height: normal;
}

.fp_code_btn.el-button {
  padding: 0;
  font-size: 14px;
}

/* 主按钮：宽度撑满表单（350），高度 / 圆角 / 字号全部跟随主题
   —— 与登录页「登录」按钮同款（实测 350×40 / 4px 圆角 / 14px 字号）。
   注意不要在按钮上写 font-size：Element 的 .el-button 本身就是 14px，
   一写就会把按钮撑高（16px → 42px），反而与登录页不一致 */
.fp_submit.el-button {
  width: 100%;
}

/* 返回登录：按钮下方左对齐 */
.fp_back_row {
  margin-top: 24px;
}

.fp_back_row .el-link {
  font-size: 14px;
}

/* 页脚：与登录页 .box_10 同款（水平居中、12px #999）。
   登录页是「内容整体居中、页脚跟在流末尾」，实测 1440×900 下页脚距底 74px；
   这里内容比登录页多一行，若也走流内会被顶到页面中间，所以改为按同一距离贴底 */
.fp_footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 74px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 视口偏矮时（内容可能顶到页脚）放弃贴底，改回跟随内容流 */
@media (max-height: 700px) {
  .fp_footer {
    position: static;
    margin-top: 48px;
  }
}

.fp_copyright {
  margin-right: 10px;
  font-size: 12px;
  color: #999;
}

.fp_beian {
  margin-left: 10px;
  font-size: 12px;
  color: #999;
}
</style>
